import type React from "react"
import styled from "styled-components"

import { type UserCoursePageInput } from "@forento/core/models/course"

import { containerClasses } from "./shared"

const PageInput: React.FC<{ page: UserCoursePageInput; chapterTitle: string }> = ({ page, chapterTitle }) => (
	<div className={containerClasses}>
		<PageHeader>
			<PageTitle>
				<ChapterName>{chapterTitle}</ChapterName>
				<Separator>/</Separator>
				<PageName>{page.title}</PageName>
			</PageTitle>
		</PageHeader>
		<InputsContainer>
			{page.inputs.map(input => (
				<Input key={input.id}>{input.text}</Input>
			))}
		</InputsContainer>
	</div>
)

const PageHeader = styled.div`
	background: #f8fafc;
	padding: 16px 20px;
	border-bottom: 1px solid #e5e7eb;
`

const PageTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	font-weight: 600;
	color: #374151;
`

const ChapterName = styled.span`
	color: #6b7280;
`

const Separator = styled.span`
	color: #d1d5db;
`

const PageName = styled.span`
	color: #111827;
`

const InputsContainer = styled.div`
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`

const Input = styled.div`
	color: #374151;
	font-size: 14px;
	line-height: 1.5;
	background: #f9fafb;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	padding: 12px;
	transition: all 0.2s ease;

	&:hover {
		background: #f3f4f6;
		border-color: #d1d5db;
	}
`

export default PageInput
